import { render, staticRenderFns } from "./Pharmacies.vue?vue&type=template&id=ed5e81d4"
import script from "./Pharmacies.vue?vue&type=script&lang=js"
export * from "./Pharmacies.vue?vue&type=script&lang=js"
import style0 from "./Pharmacies.vue?vue&type=style&index=0&id=ed5e81d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports